export default function getTenantFromPath() {
    if (!window.location) {
        return "";
    }
    var subdomain = window.location.hostname.split(".")[0];
    if (exceptions.indexOf(subdomain) > -1) {
        return "";
    }
    return subdomain;
}
export var exceptions = [
    "perkbox",
    "www",
    "localhost",
    "app"
];
